import React from 'react'

const TabControl = ({ index, isActive, iconUrl, title, onClick })  => {
    function tabControlOnClick(){
        onClick(index);
    }
    
    return (
        <div className={ isActive ? "active" : "" } onClick={tabControlOnClick}>
            <div className="iconContainer">
                {
                    iconUrl != undefined ?
                        <img src={iconUrl}
                             alt={title}
                             className="contentTopIcon"/>
                        : null
                }
            </div>
            <h4>{title}</h4>
        </div>
    )
}

export default TabControl;